import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { DOCUMENTOS_LEGALES } from '../documentos';

/**
 * Pie de página (P-01): enlaza a los cinco documentos legales desde cualquier pantalla —
 * `routes/__root.tsx` no tenía ninguno antes de esta tarea. Se monta como último hijo del layout
 * raíz.
 *
 * Sin `mx-auto` en la raíz de este componente a propósito: el hijo directo del contenedor raíz
 * `flex flex-col` de `__root.tsx` es este `<footer>` (sin márgenes automáticos, se estira sin
 * problema como flex-item), y el `mx-auto max-w-3xl px-4 sm:px-6` — el mismo ancho de lectura que
 * `<main>` — vive en el `<div>` interior, que ya no es un flex-item sino flujo de bloque normal
 * dentro del `<footer>`. Misma trampa que documenta tres veces `__root.tsx` (§ JSDoc de `Layout`),
 * resuelta aquí con un envoltorio interior en vez de uno exterior porque este componente, a
 * diferencia de `AvisoModoVisitante`, controla su propia raíz.
 */
export const PieLegal = (): React.JSX.Element => {
	const { t } = useTranslation('legal');

	return (
		<footer className='border-border border-t bg-paper-2'>
			<div className='mx-auto flex max-w-3xl flex-wrap gap-x-4 gap-y-2 px-4 py-6 sm:px-6'>
				{DOCUMENTOS_LEGALES.map(documento => (
					<Link
						className='text-gray-ink text-sm underline hover:no-underline'
						key={documento.slug}
						params={{ documento: documento.slug }}
						to='/legal/$documento'
					>
						{t(`documentos.${documento.claveI18n}.titulo`)}
					</Link>
				))}
			</div>
		</footer>
	);
};
